import * as React from "react";
import { useHistory, useParams } from "react-router-dom";
import { logger } from "@origin-digital/reporting-client";
import { Column, Columns, Stack } from "@origin-digital/ods-core";
import { routes } from "../../helpers/router.helper";
import { Slug } from "../../router";
import { useAppContext } from "../../AppContext";
import { FeedbackButtonsController } from "../FeedbackButtons";
import { Loading } from "../Loading";
import { useDaxi } from "../../services/useDaxi";
import { ArticleBody } from "./ArticleBody";

interface IArticleRes {
  title: string;
  body: string;
  attachments: string;
  attachmentUrls: [];
  likesCount: number;
  titleAndBodyHash: number;
  actions: {};
}

interface IProps {
  articleId: string;
}

const path = "/api/kb/v1/getArticleData";

export const ArticleBodyController = ({ articleId }: IProps) => {
  const { config, visitorToken } = useAppContext();
  const { category, subCategory } = useParams() as Record<Slug, string>;
  const history = useHistory();

  const params = visitorToken
    ? {
        kb: config.bold360kb,
        id: articleId,
        visitorToken,
      }
    : undefined;
  const url = `${config.bold360host}${path}`;
  const { data, error } = useDaxi<IArticleRes>(url, {
    xhr: true,
    params,
    includeCommonHeaders: false,
    ttlInMin: config.ttl,
    shouldExecute: !!visitorToken,
  });

  if (error) {
    logger.error(`ArticleBodyController article id: ${articleId}`);
    history.replace(routes.subCategory(category, subCategory));
    return null;
  }

  return data ? (
    <Columns collapseBelow="md" space="xlarge">
      <Column width="2/3">
        <Stack space="large">
          <ArticleBody title={data.title} body={data.body} />
          <FeedbackButtonsController articleId={articleId} />
        </Stack>
      </Column>
      <Column>
        <></>
      </Column>
    </Columns>
  ) : (
    <Loading />
  );
};
